import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-desktop-warning-dialog',
  templateUrl: './desktop-warning-dialog.component.html',
  styleUrls: ['./desktop-warning-dialog.component.scss']
})
export class DesktopWarningDialogComponent {

  message: string
  constructor( 
    private translate : TranslateService,
    private dialogRef : MatDialogRef<DesktopWarningDialogComponent>
  
  ) {
    this.message = this.translate.instant("common.desktop_warning")
  }
  submit() {
    this.dialogRef.close()
  }
}
